// frontend/src/assets/logo.js

import fallbackLogoPng from "./logo.png";

// If you want to keep an SVG fallback in the bundle too, you can also import it:
// import fallbackLogoSvg from "./logo-old.svg";

export function getThemeLogoSrc() {
  const t = window.__EXPO_THEME__;
  if (t && typeof t.logo === "string" && t.logo.trim()) return t.logo.trim();
  return null;
}

export function getLogoSrc() {
  return getThemeLogoSrc() || fallbackLogoPng;
}

/**
 * A safe logo component that works everywhere:
 * - theme.json can point to /branding/client-logo.png or /branding/client-logo.svg
 * - falls back to bundled logo.png
 */
export default function BrandLogo(props) {
  const { className, alt = "Logo", ...rest } = props;
  return <img src={getLogoSrc()} className={className} alt={alt} {...rest} />;
}
